import { render, staticRenderFns } from "./contact-integrations-link-icons.vue?vue&type=template&id=799b6ae5&scoped=true"
import script from "./contact-integrations-link-icons.vue?vue&type=script&lang=js"
export * from "./contact-integrations-link-icons.vue?vue&type=script&lang=js"
import style0 from "./contact-integrations-link-icons.vue?vue&type=style&index=0&id=799b6ae5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799b6ae5",
  null
  
)

export default component.exports